import { render, staticRenderFns } from "./RoutingTable.vue?vue&type=template&id=83e6a626&scoped=true&"
import script from "./RoutingTable.vue?vue&type=script&lang=js&"
export * from "./RoutingTable.vue?vue&type=script&lang=js&"
import style0 from "./RoutingTable.vue?vue&type=style&index=0&id=83e6a626&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83e6a626",
  null
  
)

export default component.exports